if(typeof vtkjs === 'undefined') { var e = new Error("Cannot find module 'vtkjs'"); e.code = 'MODULE_NOT_FOUND'; throw e; }

module.exports = vtkjs;